import { dataCivil, deISO, paraISO, ultimoDiaDoMes } from "./data.js";
import { diaUtilAnterior } from "./feriados.js";
export function competencia(ano, mes) {
    if (mes < 1 || mes > 12)
        throw new Error(`mes invalido: ${mes}`);
    return { ano, mes };
}
/** Formato canonico usado como id de documento: "2026-01". */
export function competenciaId(c) {
    return `${c.ano}-${String(c.mes).padStart(2, "0")}`;
}
export function deCompetenciaId(id) {
    const [a, m] = id.split("-").map(Number);
    if (a === undefined || m === undefined)
        throw new Error(`competencia invalida: ${id}`);
    return competencia(a, m);
}
export function proximaCompetencia(c) {
    return c.mes === 12 ? competencia(c.ano + 1, 1) : competencia(c.ano, c.mes + 1);
}
export function competenciaAnterior(c) {
    return c.mes === 1 ? competencia(c.ano - 1, 12) : competencia(c.ano, c.mes - 1);
}
export function comparaCompetencia(a, b) {
    return a.ano - b.ano || a.mes - b.mes;
}
/**
 * Vencimento do DARF: ultimo dia UTIL do mes seguinte ao do recebimento.
 * (Lei 7.713/1988 — recolhimento mensal obrigatorio.)
 */
export function vencimento(c) {
    const seguinte = proximaCompetencia(c);
    return diaUtilAnterior(ultimoDiaDoMes(seguinte.ano, seguinte.mes));
}
export function competenciaDoRecebimento(dataRecebimento) {
    return competencia(dataRecebimento.ano, dataRecebimento.mes);
}
/** Competencias de `de` ate `ate`, inclusive. */
export function intervaloCompetencias(de, ate) {
    const out = [];
    let cur = de;
    while (comparaCompetencia(cur, ate) <= 0) {
        out.push(cur);
        cur = proximaCompetencia(cur);
        if (out.length > 600)
            throw new Error("intervalo de competencias absurdo");
    }
    return out;
}
/**
 * Competencias do ano-calendario cujo mes de recebimento ja se encerrou —
 * ou seja, aquelas sobre as quais o contribuinte ja tem o que declarar.
 * O mes corrente so entra depois de terminar (regime de caixa).
 */
export function competenciasEncerradas(ano, hoje) {
    const atual = competencia(hoje.ano, hoje.mes);
    return intervaloCompetencias(competencia(ano, 1), competencia(ano, 12)).filter((c) => comparaCompetencia(c, atual) < 0);
}
/** Competencias encerradas cujo DARF ja passou do vencimento em `hoje`. */
export function competenciasVencidas(ano, hoje) {
    return competenciasEncerradas(ano, hoje).filter((c) => paraISO(vencimento(c)) < paraISO(hoje));
}
export { dataCivil, deISO, paraISO };
//# sourceMappingURL=competencia.js.map